var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 78,
    viewBox: "0 0 354 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.30796 31.7063C0.271624 32.0885 -0.258657 33.2384 0.123545 34.2748C0.505748 35.3111 1.6557 35.8414 2.69204 35.4592L1.30796 31.7063ZM224.993 61.6776L226.242 63.2397L226.302 63.1914L226.358 63.1386L224.993 61.6776ZM162.659 71.6586L163.457 69.8247L162.659 71.6586ZM2.69204 35.4592C24.9897 27.2358 61.4221 16.1256 98.1725 9.54529C116.546 6.25541 134.955 4.1061 151.69 4.00382C168.453 3.90138 183.391 5.85462 194.911 10.6608L196.451 6.96919C184.224 1.86826 168.676 -0.100064 151.666 0.0038929C134.63 0.108012 115.981 2.29306 97.4675 5.60791C60.4437 12.2371 23.782 23.4178 1.30796 31.7063L2.69204 35.4592ZM194.911 10.6608C218.452 20.4822 227.577 31.0175 229.975 39.6974C232.358 48.3199 228.29 55.8571 223.627 60.2165L226.358 63.1386C231.713 58.1331 236.736 49.1461 233.831 38.6321C230.942 28.1755 220.402 16.962 196.451 6.96919L194.911 10.6608ZM223.744 60.1155C218.94 63.9561 210.063 69.1271 199.248 71.9507C188.453 74.7689 175.854 75.2195 163.457 69.8247L161.861 73.4925C175.288 79.3356 188.846 78.8004 200.258 75.821C211.649 72.847 221.027 67.4085 226.242 63.2397L223.744 60.1155ZM163.457 69.8247C155.914 66.5425 152.212 61.3979 151.549 55.6827C150.874 49.8585 153.301 42.9768 159.031 36.268C170.473 22.872 194.613 10.815 229.445 10.815V6.81499C193.781 6.81499 168.387 19.1561 155.99 33.6701C149.8 40.9162 146.732 48.8674 147.575 56.1434C148.432 63.5283 153.263 69.751 161.861 73.4925L163.457 69.8247ZM229.445 10.815C264.51 10.815 289.826 15.4105 309.018 21.1287C328.256 26.8605 341.314 33.6983 352.211 38.3778L353.789 34.7024C343.166 30.1402 329.695 23.1155 310.16 17.2952C290.579 11.4612 264.877 6.81499 229.445 6.81499V10.815Z",
    fill: "url(#paint0_linear_3_931)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_931",
    x1: 2,
    y1: 35.2701,
    x2: 353,
    y2: 38.9942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA9AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA9AA",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector1.249a2ab77ca4960630175e968c146a6c.svg";
export { ForwardRef as ReactComponent };